import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { BirthDateVerificationProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { EventsNames } from '~/enums/Events';
import { useTrack } from '~/hooks/track';
import { PopupWrapper } from '@sunbit-dev/purchase-common/src/components/popup/Popup';
import { newPopup as Popup } from '@sunbit-dev/web-ui-lib';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import { loanApplicationNetworkService } from '~/services/LoanApplicationNetworkService';
import { DateOfBirthField } from '@sunbit-dev/purchase-common/src/components/fields/dateOfBirthField/DateOfBirthField';
import { addError } from '~/store/reducers/errors/errors';
import { useDispatch } from 'react-redux';
import { convertDateToBEPattern } from '@sunbit-dev/purchase-common/src/utilities/date';
import { convertEventToError } from '@sunbit-dev/purchase-common/src/enums/utils';
import { PopupTestIds } from '~/enums/TestIds';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

export const BirthDateVerification = styled(({ className, onClose }: BirthDateVerificationProps) => {
  const [dateOfBirth, setDateOfBirth] = useState<string>('');
  const { t } = useTranslation('components', { keyPrefix: 'birth_date_verification' });
  const { track } = useTrack();
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    try {
      const { customer } = await loanApplicationNetworkService.validateCustomer(dateOfBirth);
      onClose(customer);
    } catch (error) {
      dispatch(addError({ eventName: convertEventToError(EventsNames.validatePinCode), payload: error }));
    }
  }, [dateOfBirth]);

  const onDateOfBirthChange = useCallback(({ value }) => {
    const currentDate = convertDateToBEPattern(value);
    setDateOfBirth(currentDate);
  }, []);

  useEffect(() => {
    track({ eventName: EventsNames.dateOfBirthVerificationPopup, type: TrackCategory.View });
  }, []);

  return (
    <PopupWrapper fullScreenOnMobile>
      <PrivacyAllowanceLayer>
        <Popup
          className={className}
          blueButtonAction={onSubmit}
          blueButtonText={t('button_label')}
          boldText={t('title')}
          dataTestId={PopupTestIds.ProvePopup}
          isBlueButtonDisabled={!dateOfBirth}
          fullScreenOnMobile
          noLightBox
        >
          <h2 className="sub-title">{t('sub_title')}</h2>
          <PrivacyAllowanceLayer privacyLevel={PrivacyOptions.Mask}>
            <div className="date-of-birth-input-container">
              <DateOfBirthField
                className="field"
                name="date-of-birth"
                placeholder={t('date_of_birth_placeholder')}
                hidePlaceholderAsTitle={true}
                onChange={onDateOfBirthChange}
                value={dateOfBirth}
                dataTestId="date-of-birth-field"
                inputDataTestId="date-of-birth-input"
                version2={true}
                isBlockView={true}
              />
            </div>
          </PrivacyAllowanceLayer>
        </Popup>
      </PrivacyAllowanceLayer>
    </PopupWrapper>
  );
})`
  ${styles.BirthDateVerification}
`;
